<template>
	<div class="head-wrap">
		<v-container py-0 text-xs-right>
			<router-link to="/">
				<img src="img/logo1.png" class="icon">
			</router-link>
		</v-container>
	</div>

	
</template>

<script>
export default {
  name: 'topline',
  data () {
    return {
	
    }
  },
  methods:{
		
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
	height:25px;
	display:inline-block;
	margin: 5px 5px 5px 5px;
}
.head-wrap{
	background-color:rgb(191, 87, 0);
	height:35px;
}
</style>



// WEBPACK FOOTER //
// src/components/TopLine.vue